import React from 'react';

import { ActivityLogsList } from 'src/components/activityLog';
import { VerificationRequestStatusBar } from 'src/components/verificationRequest';
import { InboxItemTypeWithResources } from 'src/constants/inbox';
import { useInboxItemById } from 'src/hooks/inboxItem';
import { useVerificationRequest } from 'src/hooks/verificationRequest';

import { InboxItemContentApiVerificationRequest } from '../InboxItemContentApiVerificationRequest';
import { InboxItemContentResources } from '../InboxItemContentResources';
import {
  InboxItemContentVerificationRequestCreateCommentForm,
  InboxItemContentVerificationRequestPaymentStatus,
  InboxItemContentVerificationRequestVerifierStaff,
} from '../InboxItemContentVerificationRequest';
import { InboxItemContentWrapper } from '../InboxItemContentWrapper';

type InboxItemContentVerifierStaffProps = {
  inboxItemId: string | undefined;
};

export const InboxItemContentVerifierStaff: React.FC<InboxItemContentVerifierStaffProps> = ({
  inboxItemId,
}) => {
  const { inboxItem } = useInboxItemById(inboxItemId);
  const { verificationRequest } = useVerificationRequest({ inboxItemId });

  const inboxItemContent = React.useMemo(() => {
    switch (inboxItem?.type) {
      case InboxItemTypeWithResources.VerificationRequest:
        return <InboxItemContentVerificationRequestVerifierStaff />;
      case InboxItemTypeWithResources.Resources:
        return <InboxItemContentResources />;
      case InboxItemTypeWithResources.ApiVerificationRequest:
        return <InboxItemContentApiVerificationRequest />;
      default:
        return null;
    }
  }, [inboxItem?.type]);

  return (
    <InboxItemContentWrapper
      statusBar={
        inboxItem?.type === InboxItemTypeWithResources.VerificationRequest && (
          <VerificationRequestStatusBar
            status={verificationRequest?.status}
            isMyVerifyRequest={verificationRequest?.isMyVerifyRequest}
          />
        )
      }
      stripePaymentStatus={
        <InboxItemContentVerificationRequestPaymentStatus inboxItemId={inboxItemId} />
      }
      activityLog={
        <React.Activity
          mode={inboxItem?.type !== InboxItemTypeWithResources.Resources ? 'visible' : 'hidden'}
        >
          <InboxItemContentVerificationRequestCreateCommentForm />
          <ActivityLogsList inboxItemId={inboxItemId} />
        </React.Activity>
      }
    >
      {inboxItemContent}
    </InboxItemContentWrapper>
  );
};
